import { Component, OnDestroy, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { SelectComponent } from '../../../../../shared/components/select/select.component';
import { LearningPlanBuilderDataService } from '../../services/learning-plan-builder-data.service';
import { DatepickerComponent } from '../../../../../shared/components/datepicker/datepicker.component';
import { InputFieldComponent } from '../../../../../shared/components/input-field/input-field.component';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-learning-plan-builder-settings',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    SelectComponent,
    DatepickerComponent,
    InputFieldComponent,
  ],
  templateUrl: './learning-plan-builder-settings.component.html',
})
export class LearningPlanBuilderSettingsComponent implements OnDestroy {
  protected readonly dataService = inject(LearningPlanBuilderDataService);

  private readonly destroy$: Subject<void> = new Subject();
  readonly optionsNotificationFrequency = [
    {
      value: 'monthly',
      key: 'monthly',
    },
  ];

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
